import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import ListUnits from "../Components/Units/listUnits.jsx";
import AddUnits from "../Components/Units/addUnits.jsx";
import EditUnits from "../Components/Units/editUnits.jsx";
import ViewUnits from "../Components/Units/viewUnits.jsx";

const UnitsRoutes = () => {
  const { admin } = useSelector((state) => state.admin || {});
  const accessCode = admin?.data?.access_code || [];

  const canAdd = Array.isArray(accessCode) && accessCode.includes('add');
  // const canEdit = Array.isArray(accessCode) && accessCode.includes('edit');
  return (
    <Routes>
      <Route path="/furnishing" element={<ListUnits></ListUnits>}></Route>
      <Route path="/furnishing/add" element={canAdd ? <AddUnits></AddUnits> : <Navigate to="/furnishing" replace />}></Route>
      <Route
        path="/furnishing/edit/:id"
        element={<EditUnits></EditUnits>}
      ></Route>
      <Route
        path="/furnishing/view/:id"
        element={<ViewUnits></ViewUnits>}
      ></Route>
    </Routes>
  );
};

export default UnitsRoutes;
